<template>
  <v-layout align-center class="measurements-toolbar-container" column>
    <v-tooltip
      v-for="tool in tools"
      :key="tool.id"
      color="primary"
      left
      open-delay="100"
    >
      <template v-slot:activator="{ on }">
        <v-btn
        
          fab
          x-small
          v-on="on"
          @click="toggleTool(tool.id)"
          color="primary"
          class="ma-1"
        >
          <v-icon
            size="20"
            :color="
              selectedMeasurementTool === tool.id ? 'accent' : 'secondary'
            "
          >
            {{ tool.icon }}
          </v-icon>
        </v-btn>
      </template>
      <span style="font-size: 9px">{{ tool.label }}</span>
    </v-tooltip>

    <v-tooltip color="primary"  left open-delay="100">
      <template v-slot:activator="{ on }">
        <v-btn
       
          fab
          v-on="on"
          @click="escape"
          color="primary"
          style="width: 25px; height: 25px"
          class="ma-1"
        >
          <v-icon size="15">{{ escapeButton.icon }}</v-icon>
        </v-btn>
      </template>
      <span style="font-size: 9px">{{ escapeButton.label }}</span>
    </v-tooltip>
  </v-layout>
</template>

<script>
import { bus } from "@/main";
import { mapActions } from "vuex";


export default {
  name: "MeasurementsToolbar",


  props: {
    vectorSource: {
      required: true
    },

    isNetwork: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    selectedMeasurementTool() {
      return this.$store.getters.getSelectedMeasurementTool;
    },

    tools() {
      return [
        { id: "length", label: this.$i18n.t("Length"), icon: "linear_scale" },
        {
          id: "area",
          label: this.$i18n.tc("Area", 1),
          icon: "mdi-crop-square"
        },
        { id: "angle", label: this.$i18n.t("Azimuth"), icon: "mdi-angle-acute" }
      ];
    },

    escapeButton() {
      if (!this.numberOfMeasurementFeatures) {
        return { label: this.$i18n.t("CloseToolbar"), icon: "close" };
      } else {
        return {
          label: this.$i18n.t("ClearMeasurements"),
          icon: "layers_clear"
        };
      }
    },

    numberOfMeasurementFeatures() {
      if (this.vectorSource) {
        return this.vectorSource.getFeatures().length;
      } else return 0;
    },

    selectedToolsAction() {
      return this.$store.getters.tools_selectedAction;
    },

    selectedCreateTool() {
      return this.$store.getters.tools_selectedObjectLayer;
    }
  },

  methods: {
    ...mapActions([
      "setMeasurementsToolbarState",
      "setSelectedMeasureTool",
      "SET_TOOL_ACTION"
    ]),

    toggleTool(toolName) {
      let selectedTool = "";
      if (this.selectedMeasurementTool !== toolName) {
        selectedTool = toolName;
      }
      if (selectedTool !== "") {
        this.deactivateOtherMapTools();
      }
      this.setSelectedMeasureTool(selectedTool);
    },

    deactivateOtherMapTools() {
      if (
        this.selectedToolsAction === "create" ||
        this.selectedCreateTool !== ""
      ) {
        bus.$emit("deselect-selected-object-to-create");
      } else if (this.selectedToolsAction === "select") {
        bus.$emit("reset-area");
        this.SET_TOOL_ACTION("");
      }
    },

    escape() {
      if (!this.numberOfMeasurementFeatures) {
        this.setMeasurementsToolbarState(false);
      } else {
        this.$emit("clear");
      }
    }
  },

  watch: {
    selectedCreateTool(selectedTool) {
      if (selectedTool !== "") {
        this.setSelectedMeasureTool("");
      }
    },

    selectedToolsAction(newValue) {
      if (newValue === "select") {
        this.setSelectedMeasureTool("");
      }
    }
  },

  destroyed() {
    this.setSelectedMeasureTool("");
    this.$emit("resetMeasurements");
  }
};
</script>

<style scoped>
.measurements-toolbar-container {
  width: fit-content;
  height: fit-content;
  position: absolute;
  top: 60px;
  right: 15px;
  z-index: 7;
}

</style>



// WEBPACK FOOTER //
// src/components/Home/Toolbars/MeasurementsToolbar.vue